/* Ohbears store scripts: tabs, product form, gallery, cart.
   Plain JavaScript, no dependencies. Every block re-initialises when the
   theme editor reloads a section. */
(function () {
  'use strict';

  function formatMoney(cents, format) {
    var value = (cents / 100).toFixed(2);
    var fmt = format || '{{amount_with_comma_separator}} €';
    var withComma = value.replace('.', ',');
    var noDecimals = Math.round(cents / 100).toString();
    return fmt
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, withComma)
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, noDecimals)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, noDecimals)
      .replace(/\{\{\s*amount\s*\}\}/, value);
  }

  /* Tabs */
  function initTabs(root) {
    root.querySelectorAll('[data-ob-tabs]').forEach(function (tabs) {
      if (tabs.dataset.obReady) return;
      tabs.dataset.obReady = '1';
      var buttons = Array.prototype.slice.call(tabs.querySelectorAll('[role="tab"]'));
      function select(btn, focus) {
        buttons.forEach(function (b) {
          var on = b === btn;
          b.setAttribute('aria-selected', on ? 'true' : 'false');
          b.tabIndex = on ? 0 : -1;
          var panel = document.getElementById(b.getAttribute('aria-controls'));
          if (panel) panel.hidden = !on;
        });
        if (focus) btn.focus();
      }
      buttons.forEach(function (btn, i) {
        btn.addEventListener('click', function () { select(btn, false); });
        btn.addEventListener('keydown', function (e) {
          var next = null;
          if (e.key === 'ArrowRight') next = buttons[(i + 1) % buttons.length];
          if (e.key === 'ArrowLeft') next = buttons[(i - 1 + buttons.length) % buttons.length];
          if (e.key === 'Home') next = buttons[0];
          if (e.key === 'End') next = buttons[buttons.length - 1];
          if (next) { e.preventDefault(); select(next, true); }
        });
      });
    });
  }

  /* Gallery thumbnails */
  function initGallery(root) {
    root.querySelectorAll('[data-ob-gallery]').forEach(function (gallery) {
      if (gallery.dataset.obReady) return;
      gallery.dataset.obReady = '1';
      var main = gallery.querySelector('[data-ob-main]');
      gallery.querySelectorAll('[data-ob-thumb]').forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          var img = main && main.querySelector('img');
          if (img) {
            img.src = thumb.dataset.src;
            img.removeAttribute('srcset');
            img.alt = thumb.dataset.alt || '';
          }
          gallery.querySelectorAll('[data-ob-thumb]').forEach(function (t) {
            t.setAttribute('aria-current', t === thumb ? 'true' : 'false');
          });
        });
      });
    });
  }

  /* Product form: variant, purchase type (subscription, one-time or pack), quantity, price */
  function initProduct(root) {
    root.querySelectorAll('[data-ob-product]').forEach(function (wrap) {
      if (wrap.dataset.obReady) return;
      wrap.dataset.obReady = '1';
      var dataEl = wrap.querySelector('[data-ob-product-json]');
      if (!dataEl) return;
      var product;
      try { product = JSON.parse(dataEl.textContent); } catch (e) { return; }
      var moneyFormat = wrap.dataset.moneyFormat;
      var form = wrap.querySelector('form');
      var idInput = form.querySelector('input[name="id"]');
      var planInput = form.querySelector('input[name="selling_plan"]');
      var qtyInput = form.querySelector('[data-ob-qty-input]') || form.querySelector('input[name="quantity"]');
      var qtyReal = form.querySelector('[data-ob-qty-real]');
      var atc = form.querySelector('[data-ob-atc]');
      var atcLabel = atc ? atc.dataset.label : '';

      function currentVariant() {
        var options = [];
        wrap.querySelectorAll('[data-ob-option]').forEach(function (fs) {
          var checked = fs.querySelector('input:checked');
          if (checked) options.push(checked.value);
        });
        if (!options.length) return product.variants.find(function (v) { return v.id == idInput.value; }) || product.variants[0];
        return product.variants.find(function (v) {
          return v.options.every(function (o, i) { return o === options[i]; });
        });
      }

      /* Discount pill in the corner of a plan: hidden when there is no saving */
      var pillTpl = wrap.dataset.pillTpl || '';
      function setPill(type, ref, price) {
        var el = wrap.querySelector('[data-ob-pill="' + type + '"]');
        if (!el) return;
        var save = ref > price ? ref - price : 0;
        el.hidden = save <= 0;
        el.textContent = pillTpl
          .replace('[pourcentage]', ref > 0 ? Math.round(save * 100 / ref) : 0)
          .replace('[economie]', formatMoney(save, moneyFormat));
      }

      function purchaseType() {
        var checked = wrap.querySelector('input[name="ob-purchase"]:checked');
        return checked ? checked.value : 'once';
      }

      function update() {
        var variant = currentVariant();
        if (!variant) {
          atc.disabled = true;
          atc.textContent = atc.dataset.unavailable;
          return;
        }
        idInput.value = variant.id;
        var allocation = (variant.selling_plan_allocations || [])[0];
        var qty = Math.max(1, parseInt(qtyInput.value, 10) || 1);

        var onceEl = wrap.querySelector('[data-ob-price="once"]');
        var subEl = wrap.querySelector('[data-ob-price="sub"]');
        var subCompare = wrap.querySelector('[data-ob-compare="sub"]');
        if (onceEl) onceEl.textContent = formatMoney(variant.price, moneyFormat);
        var onceCompare = wrap.querySelector('[data-ob-compare="once"]');
        var onceRef = variant.compare_at_price || 0;
        if (onceCompare) onceCompare.textContent = onceRef > variant.price ? formatMoney(onceRef, moneyFormat) : '';
        setPill('once', onceRef, variant.price);
        if (allocation) {
          var subRef = allocation.compare_at_price > allocation.price ? allocation.compare_at_price : variant.price;
          setPill('sub', subRef, allocation.price);
        }
        if (subEl && allocation) subEl.textContent = formatMoney(allocation.price, moneyFormat);
        if (subCompare && allocation) {
          subCompare.textContent = allocation.compare_at_price > allocation.price ? formatMoney(allocation.compare_at_price, moneyFormat) : '';
        }

        var packRadio = wrap.querySelector('input[name="ob-purchase"][value="pack"]');
        var packQty = packRadio ? Math.max(1, parseInt(packRadio.dataset.packQty, 10) || 2) : 1;
        var packFull = variant.price * packQty;
        var packOff = 0;
        if (packRadio) {
          if (packRadio.dataset.packOff !== undefined) packOff = Math.min(packFull, Math.max(0, parseInt(packRadio.dataset.packOff, 10) || 0));
          else packOff = Math.floor(packFull * Math.max(0, parseInt(packRadio.dataset.packDiscount, 10) || 0) / 100);
        }
        var packPrice = packFull - packOff;
        if (packRadio) {
          var packEl = wrap.querySelector('[data-ob-price="pack"]');
          var packCompare = wrap.querySelector('[data-ob-compare="pack"]');
          if (packEl) packEl.textContent = formatMoney(packPrice, moneyFormat);
          if (packCompare) packCompare.textContent = packOff > 0 ? formatMoney(packFull, moneyFormat) : '';
          wrap.querySelectorAll('[data-ob-pack-pct]').forEach(function (el) { el.textContent = packFull > 0 ? Math.round(packOff * 100 / packFull) : 0; });
          wrap.querySelectorAll('[data-ob-pack-save]').forEach(function (el) { el.textContent = formatMoney(packFull - packPrice, moneyFormat); });
          wrap.querySelectorAll('[data-ob-pack-unit]').forEach(function (el) { el.textContent = formatMoney(Math.floor(packPrice / packQty), moneyFormat); });
          setPill('pack', packFull, packPrice);
        }

        var type = purchaseType();
        if (qtyReal) qtyReal.value = qty * (type === 'pack' && packRadio ? packQty : 1);
        if (planInput) {
          if (type === 'sub' && allocation) {
            planInput.value = allocation.selling_plan_id;
            planInput.disabled = false;
          } else {
            planInput.value = '';
            planInput.disabled = true;
          }
        }

        var unit = type === 'sub' && allocation ? allocation.price : (type === 'pack' && packRadio ? packPrice : variant.price);
        if (!variant.available) {
          atc.disabled = true;
          atc.textContent = atc.dataset.unavailable;
        } else {
          atc.disabled = false;
          atc.textContent = atc.dataset.showPrice === 'false' ? atcLabel : atcLabel + ' · ' + formatMoney(unit * qty, moneyFormat);
        }
      }

      wrap.querySelectorAll('input[type="radio"]').forEach(function (r) { r.addEventListener('change', update); });
      wrap.querySelectorAll('[data-ob-qty]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var v = Math.max(1, (parseInt(qtyInput.value, 10) || 1) + parseInt(btn.dataset.obQty, 10));
          qtyInput.value = Math.min(v, 10);
          update();
        });
      });
      qtyInput.addEventListener('change', update);

      /* Add-to-cart feedback: spinner while the cart drawer adds, then a short confirmation */
      var addedTimer = null;
      form.addEventListener('submit', function () {
        if (!atc || atc.disabled) return;
        window.clearTimeout(addedTimer);
        atc.classList.remove('is-added');
        atc.classList.add('is-adding');
        /* No drawer on the page: the browser navigates to the cart, nothing else to do */
      });
      if (atc && 'MutationObserver' in window) {
        new MutationObserver(function () {
          if (!atc.classList.contains('is-adding') || atc.hasAttribute('aria-busy')) return;
          atc.classList.remove('is-adding');
          if (form.querySelector('[data-ob-form-error]')) { update(); return; }
          atc.classList.add('is-added');
          atc.textContent = atc.dataset.added || atcLabel;
          addedTimer = window.setTimeout(function () { atc.classList.remove('is-added'); update(); }, 2000);
        }).observe(atc, { attributes: true, attributeFilter: ['aria-busy'] });
      }
      update();
    });
  }

  /* Cart page: change quantity or remove a line, then reload */
  function initCart(root) {
    root.querySelectorAll('[data-ob-cart]').forEach(function (cart) {
      if (cart.dataset.obReady) return;
      cart.dataset.obReady = '1';
      function change(key, quantity) {
        cart.classList.add('is-loading');
        fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: key, quantity: quantity })
        }).then(function () { window.location.reload(); })
          .catch(function () { cart.classList.remove('is-loading'); });
      }
      cart.querySelectorAll('[data-ob-line]').forEach(function (line) {
        var key = line.dataset.obLine;
        var input = line.querySelector('input[type="number"]');
        line.querySelectorAll('[data-ob-qty]').forEach(function (btn) {
          btn.addEventListener('click', function (e) {
            e.preventDefault();
            var v = Math.max(0, (parseInt(input.value, 10) || 0) + parseInt(btn.dataset.obQty, 10));
            input.value = v;
            change(key, v);
          });
        });
        if (input) input.addEventListener('change', function () { change(key, Math.max(0, parseInt(input.value, 10) || 0)); });
        var remove = line.querySelector('[data-ob-remove]');
        if (remove) remove.addEventListener('click', function (e) { e.preventDefault(); change(key, 0); });
      });
    });
  }

  function initAll(root) {
    root = root || document;
    initTabs(root);
    initGallery(root);
    initProduct(root);
    initCart(root);
  }

  document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
